const KEY = "lastRead";

export function saveLastRead({ bookId, bookName, chapter, verse = null }) {
  if (!bookId || !chapter) return null;
  const payload = {
    bookId: Number(bookId),
    bookName: bookName || null,
    chapter: Number(chapter),
    verse: verse != null ? Number(verse) : null,
    updatedAt: new Date().toISOString(),
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch (e) {}
  return payload;
}

export function getLastRead() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function clearLastRead() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {}
}

export function buildLastReadUrl(lastRead) {
  if (!lastRead || !lastRead.bookId || !lastRead.chapter) return "/biblia";
  return `/bible/book/${encodeURIComponent(
    lastRead.bookId
  )}?chapter=${encodeURIComponent(lastRead.chapter)}`;
}
